export default "__VITE_ASSET__C4r9M73O__"